import {isNotNullish} from '../../../utils/Utils';

export const CALLBACK_SCHEDULER_TIMEOUT_DELAY_MS = 50;

export class CallbackScheduler {
  private timeout: ReturnType<typeof setTimeout> | undefined = undefined;
  private callback: (() => void) | undefined;

  schedule(callback: () => void) {
    if (isNotNullish(this.timeout)) {
      return;
    }

    this.callback = callback;
    this.timeout = setTimeout(() => {
      this.callback?.();
      this.cancel();
    }, CALLBACK_SCHEDULER_TIMEOUT_DELAY_MS);
  }

  isScheduled() {
    return isNotNullish(this.timeout);
  }

  execute() {
    this.callback?.();
    this.cancel();
  }

  cancel() {
    clearTimeout(this.timeout);
    this.timeout = undefined;
    this.callback = undefined;
  }
}
